import Icon from '@/components/snippets/icon/icon'
import clsx from 'clsx'
import { useOption } from '../hooks/useOption'
import { useFilters } from '../hooks/useFilters'
import { FilterSelected } from './FilterSelected'
import { FilterSort } from './FilterSort'
import { ResultCount } from './ResultCount'

export function CollectionToolbar({ sticky = true }) {
  const { handleRemoveFilter, handleClearFilters } = useFilters()
  const activeFilters = useOption('filters', {
    defaultValue: new Set(),
    syncWithURL: true
  })

  return (
    <div
      data-plp-toolbar
      className={clsx(
        'flex flex-col w-full border-b border-neutrals-light-grey bg-primary-white',
        sticky && 'sticky z-30 top-[60px] xl:top-[82px] md-max:has-data-visible-[x-modal]:z-max'
      )}
    >
      <div className="flex items-center justify-between gap-4 md:gap-5 relative px-4 md:px-10 py-2 md:py-3.5">
        <div className="flex min-w-0 grow items-center gap-4 md:gap-5">
          <button
            className="underline btn btn-text-black btn-sm btn-inline shrink-0 whitespace-nowrap"
            data-modal-role="toggle"
            data-modal-parent="filters"
            aria-label="Toggle filters"
          >
            <Icon id="filter" className="h-4 w-4" />
            <span className="md:hidden">
              Filters{activeFilters?.size > 0 ? ` (${activeFilters.size})` : ''}
            </span>
            <span className="hidden md:inline group-data-visible/filters:hidden">Show Filter Options</span>
            <span className="hidden md:group-data-visible/filters:inline">Hide Filter Options</span>
          </button>
          <div className="hidden md:block min-w-0 flex-1 overflow-hidden">
            <FilterSelected
              variant="toolbar"
              activeFilters={activeFilters}
              onRemove={handleRemoveFilter}
              onClear={handleClearFilters}
            />
          </div>
        </div>
        <ResultCount className="md:hidden absolute inset-x-0 paragraph-sm text-center text-neutrals-secondary-grey whitespace-nowrap pointer-events-none" />
        <div className="flex shrink-0 items-center gap-4">
          <ResultCount className="md-max:hidden whitespace-nowrap paragraph-sm text-neutrals-secondary-grey" />
          <FilterSort />
        </div>
      </div>
      {!sticky && (
        <div className="block md:hidden w-full">
          <FilterSelected
            activeFilters={activeFilters}
            onRemove={handleRemoveFilter}
            onClear={handleClearFilters}
          />
        </div>
      )}
    </div>
  )
}
